import React from 'react';
import { showDialog } from 'stores/dialogSlice';
import { ReleaseVersionDomain } from 'models/ReleaseVersion';
import { useAppDispatch } from 'stores/type';
import { DefaultTemplateLayout } from 'views/layouts/DefaultTemplateLayout';

type DefaultTemplateProps = {
  headerText?: string;
  footerLinks?: {
    text: string;
    href: string;
  }[];
  showLogo?: boolean;
  onBack?(): void;
  onComment?(): void;
};

export const DefaultTemplate: React.FC<DefaultTemplateProps> = ({
  headerText,
  footerLinks,
  showLogo,
  onBack,
  onComment,
  children,
}) => {
  const dispatch = useAppDispatch();

  const handleClickHeader = React.useCallback(() => {
    if (process.env.SHOW_VERSION_DIALOG === 'true') {
      dispatch(
        showDialog({
          content: `version: ${ReleaseVersionDomain.currentVersion()}`,
        })
      );
    }
  }, [dispatch]);

  return (
    <DefaultTemplateLayout
      headerText={headerText}
      footerLinks={footerLinks}
      showLogo={showLogo}
      onBack={onBack}
      onComment={onComment}
      onClickHeader={handleClickHeader}
    >
      {children}
    </DefaultTemplateLayout>
  );
};
